import ICareerBuilderAdvanceSearch from '../types/ICareerBuilderAdvanceSearch';

export default {
  searchPattern: 'Any',
  jobTitle: {
    values: [],
    matchType: 'AND',
  },
  companies: {
    values: [],
    matchType: 'AND',
  },
  zipcode: '',
  totalExperience: {
    min: '',
    max: '',
  },
  minimumDegree: [],
  languages: [],
  hasSecurityClearance: '',
  applyLastActivity: null,
  employmentType: [],
  workAuthorization: [],
  authorizedCountries: [],
  salaryRange: {
    currency: '',
    unitTime: '',
    min: '',
    max: '',
  },
  currentlyEmployed: '',
  managementExperience: '',
  militaryExperience: [],
  minEmployeeManaged: '',
  travelPreference: '',
} as ICareerBuilderAdvanceSearch;
